<template>
  <div>
    <div
      class="global_back m-b-10"
    >
      <div class="global_content">
        <div
          class="global_left"
          @click="handleClose"
        >
          <i class="el-icon-back" />
          <span class="title">返回</span>
        </div>
        <div class="global_right">
          {{ optType==='add' ? '新增报价' :'报价详情' }}
        </div>
      </div>
    </div>
    <!-- <el-card class="m-b-20">
      <el-page-header
        :content="optType==='add' ? '新增报价' :'报价详情'"
        @back="handleClose"
      />
    </el-card> -->
    <el-card>
      <el-row :gutter="20">
        <el-col :span="16">
          <el-form
            label-width="110px"
            label-position="left"
          >
            <div class="classify-title">
              商品信息
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  label="商品"
                  :required="optType!=='detail'"
                >
                  <el-select
                    v-if="optType==='add'"
                    v-model="create.varietyCode"
                    placeholder="请选择"
                    filterable
                    @change="selectVarietyChange"
                  >
                    <el-option
                      v-for="(item) in varietyList"
                      :key="item.code"
                      :label="item.shortName"
                      :value="item.code"
                    />
                  </el-select>
                  <div v-else>
                    {{ create.varietyName }}
                  </div>
                </el-form-item>
              </el-col>
              <template v-if="optType==='detail'">
                <el-col
                  v-for="item in create.attrList"
                  :key="item.attrCode"
                  :span="12"
                >
                  <el-form-item :label="item.attrName">
                    {{ item.v }}
                  </el-form-item>
                </el-col>
              </template>
              <template v-else>
                <el-col
                  v-for="item in attrList"
                  :key="item.attrCode"
                  :span="12"
                >
                  <el-form-item
                    :label="item.attrName"
                    :required="optType!=='detail'"
                  >
                    <el-select
                      v-model="item.k"
                      filterable
                      @change="(val)=>selectAttrChange(item, val)"
                    >
                      <el-option
                        v-for="subItem in item.selList"
                        :key="subItem.k"
                        :value="subItem.k"
                        :label="subItem.v"
                      >
                        {{ subItem.v }}
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </template>
            </el-row>

            <div class="classify-title">
              报价信息
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  label="报价类型"
                  :required="optType!=='detail'"
                >
                  <el-select
                    v-if="optType==='add'"
                    v-model="create.priceType"
                    @change="selectPriceTypeChange"
                  >
                    <el-option
                      v-for="item in this.$key.myStore.priceType"
                      :key="item.id"
                      :value="item.id"
                      :label="item.name"
                    >
                      {{ item.name }}
                    </el-option>
                  </el-select>
                  <span v-else>{{ create.priceType | keyFilter('myStore', 'priceType') }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="有效期"
                  :required="optType!=='detail'"
                >
                  <el-select
                    v-if="optType==='add'"
                    v-model="create.validType"
                  >
                    <el-option
                      v-for="item in this.$key.myStore.validType"
                      :key="item.id"
                      :value="item.id"
                      :label="item.name"
                    >
                      {{ item.name }}
                    </el-option>
                  </el-select>
                  <div v-else>
                    {{ create.validType | keyFilter('myStore', 'validType') }}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item
              v-if="!!create.priceType && create.priceType!=='DX'"
              :label="!!create.unitName ? `单价(元/${create.unitName})`: '单价'"
              :required="optType!=='detail'"
            >
              <template v-if="create.priceType==='YKJ'">
                <el-input-number
                  v-if="optType==='add'"
                  v-model.trim="create.priceList[0].unitPrice"
                  :controls="false"
                  class="w220"
                />
                <span v-else>{{ create.priceList[0].unitPrice }}</span>
              </template>

              <template v-if="create.priceType==='JTJ'">
                <el-button
                  v-if="optType==='add'"
                  size="small"
                  type="primary"
                  class="m-b-10"
                  @click="toAddPrice"
                >
                  新增单价
                </el-button>
                <el-table
                  :data="create.priceList"
                  border
                >
                  <el-table-column label="单价">
                    <template v-slot="scope">
                      <el-input-number
                        v-if="optType==='add'"
                        v-model.trim="scope.row.unitPrice"
                        class="w100"
                        :controls="false"
                      />
                      <span v-else>{{ scope.row.unitPrice }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="购买量(起购量)">
                    <template v-slot="scope">
                      <el-input-number
                        v-if="optType==='add'"
                        v-model.trim="scope.row.min"
                        class="w100"
                        :controls="false"
                      />
                      <span v-else>{{ scope.row.min }} </span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    v-if="optType==='add'"
                    label="操作"
                  >
                    <template v-slot="scope">
                      <el-button
                        type="text"
                        class="red"
                        @click="toDeletePrice(scope.row, scope.$index)"
                      >
                        删除
                      </el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-form-item>
            <el-form-item
              v-if="optType==='add'"
              label="是否发布挂牌"
              :required="optType!=='detail'"
            >
              <el-radio-group
                v-if="optType==='add'"
                v-model="create.actionType"
                @change="selectActionTypeChange"
              >
                <el-radio
                  v-for="item in $key.myStore.actionType"
                  :key="item.id"
                  :label="item.id"
                >
                  {{ item.name }}
                </el-radio>
              </el-radio-group>
              <div v-else>
                {{ create.actionType | keyFilter('myStore', 'pickupType') }}
              </div>
            </el-form-item>

            <el-form-item
              v-if="create.actionType==='QT' && optType==='add'"
              label="挂牌数量"
              :required="optType!=='detail'"
            >
              <el-input
                v-model.trim="create.totalQuantity"
                class="w220"
                :maxlength="32"
              />
            </el-form-item>

            <div class="classify-title">
              交货信息
            </div>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item
                  label="仓库"
                  :required="optType!=='detail'"
                >
                  {{ create.pickupWarehouseName }}
                  <el-button
                    v-if="optType!=='detail'"
                    size="small"
                    type="primary"
                    @click="toSelectWarehouse"
                  >
                    选择
                  </el-button>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="交货地点"
                  :required="optType!=='detail'"
                >
                  {{ create.pickupPosition }}
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="提货方式"
                  :required="optType!=='detail'"
                >
                  <el-radio-group
                    v-if="optType==='add'"
                    v-model="create.pickupType"
                  >
                    <el-radio
                      v-for="item in $key.myStore.pickupType"
                      :key="item.id"
                      :label="item.id"
                    >
                      {{ item.name }}
                    </el-radio>
                  </el-radio-group>
                  <div v-else>
                    {{ create.pickupType | keyFilter('myStore', 'pickupType') }}
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
        <el-col
          v-if="optType==='detail' && create.priceType!=='DX'"
          :span="8"
          class="m-t-40"
        >
          <div class="classify-title">
            报价价格波动
          </div>
          <ve-line
            :data="chartData"
            :settings="chartSettings"
          />
        </el-col>
      </el-row>

      <footer-bar>
        <el-button
          v-if="optType!=='detail'"
          type="primary"
          @click="toSubmit"
        >
          发布
        </el-button>
        <el-button @click="handleClose">
          {{ optType!=='detail' ? '取 消' : '返 回' }}
        </el-button>
      </footer-bar>
      <warehouse
        :call-warehouse="callWarehouse"
        @returnWarehouseData="returnWarehouseData"
        @close="callWarehouse.visible=false"
      />
    </el-card>
  </div>
</template>

<script>
import api from '@/api'
import Warehouse from '@/views/my-store/components/warehouse'
import VeLine from 'v-charts/lib/line'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import Vue from 'vue'
import { checkPriceMixin } from '@/views/my-store/components/mixin'
Vue.component(VeLine.name, VeLine)

function Create () {
  return {
    priceType: '',
    varietyCode: '',
    varietyName: '',
    unitName: '',
    pickupWarehouseId: '',
    pickupWarehouseName: '',
    pickupPosition: '',
    provinceName: '',
    provinceCode: '',
    cityName: '',
    cityCode: '',
    districtCode: '',
    districtName: '',
    priceList: [{
      min: '',
      max: '',
      unitPrice: ''
    }],
    actionType: '',
    totalQuantity: '',
    pickupType: '',
    // 属性
    attrList: [],
  }
}
export default {
  name: 'HandleQuotation',
  components: {
    Warehouse
  },
  mixins: [checkPriceMixin],
  props: {
    detailData: {
      type: Object,
      default: () => { return {} }
    },
    optType: {
      type: String,
      default: ''
    },
    varietyList: {
      type: Array,
      default: () => []
    },
    marketCode: {
      type: String,
      default: ''
    }
  },

  data () {
    return {
      create: new Create(),
      callWarehouse: {
        visible: false,
        warehouseNameLike: '',
      },
      createRules: [
        { name: 'varietyCode', message: '请选择商品' },
        { name: 'priceType', message: '请选择报价类型' },
        { name: 'priceList', message: '请输入单价' },
        { name: 'validType', message: '请选择有效期' },
        { name: 'actionType', message: '请选择是否发布挂牌' },
        { name: 'pickupPosition', message: '请选择仓库' },
        { name: 'pickupType', message: '请选择提货方式' },
      ],
      chartData: {
        columns: [],
        rows: []
      },
      chartSettings: {
        xAxisName: ['报价次数']
      },
      attrList: [],
      brandCode: '',
    }
  },
  created () {
    if (this.optType !== 'add') {
      this.create = { ...this.detailData }
      // 处理价格波动折线图
      this.getChartData()
    }
  },
  methods: {
    // 处理价格波动折线图
    getChartData () {
      // 电询的情况不展示
      if (this.create.priceType === 'DX') {
        return
      }
      this.chartData.rows = this.create.priceHistoryList.map((item, index) => {
        // 阶梯价的时候区分最高价和最低价
        if (this.create.priceType === 'JTJ') {
          let min = ''
          let max = ''
          item.map(price => {
            if (price.tag === 'MAX') {
              max = price.unitPrice
            } else if (price.tag === 'MIN') {
              min = price.unitPrice
            }
          })
          item = {
            '报价次数': (index + 1).toString(),
            '最高价': max,
            '最低价': min,
          }
        } else {
          // 一口价的时候直接显示价格
          item = {
            '报价次数': (index + 1).toString(),
            '价格': item[0].unitPrice,
          }
        }
        return item
      })
      this.chartData.columns = this.create.priceType === 'JTJ' ? ['报价次数', '最高价', '最低价'] : ['报价次数', '价格']
    },
    // 改变品种
    selectVarietyChange (val) {
      const cueVariety = this.varietyList.find(item => item.code === val)
      this.create.varietyName = cueVariety.shortName
      this.create.varietyUrl = cueVariety.img
      this.create.unitName = cueVariety.unitName
      // 重置属性并重新获取
      this.attrList = []
      this.getVarietyAttr(val)
      // 重置报价类型和单价
      this.create.priceType = ''
      this.create.priceList = [{
        min: '',
        max: '',
        unitPrice: ''
      }]
    },
    // 获取品种动态属性
    getVarietyAttr (varietyCode) {
      if (!this.marketCode) {
        this.$message.warning('当前客户没有市场,无法获取品种属性')
        return
      }
      api.myStore.getVarietyAttr(this.marketCode, varietyCode).then(res => {
        this.attrList = res.data.attrList
      })
    },
    // 属性选择改变事件 attr当前属性  k 属性当前选中k
    selectAttrChange (attr, k) {
      this.$forceUpdate()
      const selectedAttr = attr.selList.find(item => item.k === k)
      attr = { ...attr, ...selectedAttr }
      const curItemIndex = this.attrList.findIndex(item => item.attrCode === attr.attrCode)
      if (curItemIndex > -1) {
        this.attrList[curItemIndex] = attr
      }
    },
    // 选择仓库
    toSelectWarehouse () {
      this.callWarehouse.visible = true
    },
    // 返回仓库信息
    returnWarehouseData (data) {
      this.callWarehouse.id = data.id
      this.callWarehouse.warehouseNameLike = data.warehouseName
      this.callWarehouse.warehouseNoLike = data.warehouseNo
      this.create.pickupPosition = data.address
      this.create.pickupWarehouseId = data.id
      this.create.pickupWarehouseName = data.warehouseName
      // 省市区
      const { provinceName, provinceCode, cityName, cityCode, districtCode, districtName } = data
      const region = { provinceName, provinceCode, cityName, cityCode, districtCode, districtName }
      Object.keys(region).map(item => {
        this.create[item] = region[item]
      })
    },
    // 新增价格
    toAddPrice () {
      if (this.create.priceList.length === 5) {
        this.$message.warning('最多5条阶梯价')
        return
      }
      this.create.priceList.push({
        min: undefined, // el-input-number 初始值为undefined不会默认一个0
        max: '',
        unitPrice: undefined
      })
    },
    // 删除价格
    toDeletePrice (row, index) {
      this.create.priceList.splice(index, 1)
    },
    // 报价类型改变时重置priceList
    selectPriceTypeChange (val) {
      if (val === 'DX') {
        this.create.actionType = 'Q'
      }
      this.create.priceList = [{
        min: undefined, // el-input-number 初始值为undefined不会默认一个0
        max: '',
        unitPrice: undefined
      }]
    },
    // 是否发布挂牌改变时清空挂牌数量
    selectActionTypeChange () {
      this.create.totalQuantity = ''
    },
    validator () {
      this.create.attrList = []
      let checkAttr = true
      this.attrList.some(item => {
        if (!item.k) {
          checkAttr = false
          this.$message.warning('请选择' + item.attrName)
          return true
        }
        const { id, attrCode, attrName, k, v } = item
        this.create.attrList.push({ id, attrCode, attrName, k, v })
      })
      if (!checkAttr) {
        return false
      }

      if (this.$utils.checkEmptyRules(this.create, this.createRules)) {
        return false
      }
      // minxin
      if (!this.checkPrice(this.create.priceType, this.create.priceList)) {
        return false
      }

      if (this.create.actionType === 'QT' && !this.create.totalQuantity) {
        this.$message.warning('发布挂牌时挂牌数量必填')
        return false
      }
      const regInt = /^[0-9]*[1-9][0-9]*$/
      if (this.create.totalQuantity && !regInt.test(this.create.totalQuantity)) {
        this.$message.warning('挂牌数量必须为整数')
        return false
      }
      return true
    },
    // 提交
    toSubmit () {
      if (!this.validator()) return
      // 电询时清空价格字段
      if (this.create.priceType === 'DX') {
        this.create.priceList = null
      }
      api.myStore.createOrUpdateQuotation(this.create).then(res => {
        this.$message.success('操作成功')
        this.$emit('refresh')
        this.handleClose()
      })
    },
    handleClose () {
      this.$emit('close')
    }
  },
}
</script>

<style lang="scss" scoped>
.global_back {
  padding: 18px 20px;
  border-bottom: 1px solid #ebeef5;
  background-color:white;
  .global_content {
    display: flex;
    .global_left{
      cursor: pointer;
      margin-right: 40px;
      position: relative;
      .el-icon-back{
        font-size: 18px;
        margin-right: 6px;
        -ms-flex-item-align: center;
        align-self: center;
      }
      .title {
          font-size: 14px;
          font-weight: 500;
        &::after{
          content: "";
          position: absolute;
          width: 1px;
          height: 16px;
          right: -20px;
          top: 50%;
          -webkit-transform: translateY(-50%);
          transform: translateY(-50%);
          background-color: #dcdfe6;
        }
      }
    }
    .global_right{
      font-size: 18px;
      color: #303133;
    }
  }
}
</style>
